module.exports = __webpack_public_path__ + "static/media/FitnessRookie.81ba6f9d.svg";